import {Component, Input, OnInit} from '@angular/core';
import {Brick} from './brick';

@Component({
  selector: 'app-brick',
  templateUrl: './brick.component.html',
  styleUrls: ['./brick.component.css']
})
export class BrickComponent implements OnInit {

  @Input() size = 10;
  @Input() brick: Brick;

  constructor() { }

  ngOnInit(): void {
  }

  get style(): any {
    return {
      width: `${this.size - 2}px`,
      height: `${this.size - 2}px`,
      'background-color': this.brick.color,
    };
  }

  get brickClass(): string {
    if (this.brick.empty) {
      return 'empty';
    }
    return 'wall';
  }

}
